import { addExternalScript } from '../../includes/utils';
import { gtagDataLayer } from './datalayer';

/* ------------------------------------------------------------ */
/* -- Google Init -- */
/* ------------------------------------------------------------ */
const googleInit = () => {
  /*  Global site tag (gtag.js) */
  addExternalScript({ src: 'https://www.googletagmanager.com/gtag/js?id=G-18CZGP5S05', async: true }).catch(err =>
    console.error(err),
  );
  /* Gtag DataLayer */
  gtagDataLayer();
};

export default googleInit;
